/**
 * Station partner form submits a single range as `frontDeskHours` (and duplicates to open/staffed).
 * Admin reads/writes that field first so UI matches the Station "Front Desk Hours" control.
 */

export type HourRangeLike = { from?: string | null; to?: string | null };

export type PartnerInfoHours = {
	frontDeskHours?: HourRangeLike | null;
	openHours?: HourRangeLike | null;
	workTime?: Array<{ hour?: HourRangeLike | null }> | null;
	staffedHours?: HourRangeLike | null;
	staffHours?: HourRangeLike | null;
	staffedTime?: HourRangeLike | null;
};

function trimPair(range?: HourRangeLike | null): { from: string; to: string } | null {
	if (!range) return null;
	const from = String(range.from ?? "").trim();
	const to = String(range.to ?? "").trim();
	if (!from || !to) return null;
	return { from, to };
}

/** Same source order as backend FormService.resolveOpenHours — front desk first. */
export function resolveFrontDeskHoursRange(partnerInfo?: PartnerInfoHours | null): { from: string; to: string } {
	const pi = partnerInfo || {};
	return (
		trimPair(pi.frontDeskHours) ||
		trimPair(pi.openHours) ||
		trimPair(pi.workTime?.[0]?.hour) || { from: "", to: "" }
	);
}

/** Staff row; falls back to front desk when absent (legacy / single-range submissions). */
export function resolveStaffedHoursRange(partnerInfo?: PartnerInfoHours | null): { from: string; to: string } {
	const pi = partnerInfo || {};
	return (
		trimPair(pi.staffedHours) ||
		trimPair(pi.staffHours) ||
		trimPair(pi.staffedTime) ||
		resolveFrontDeskHoursRange(pi)
	);
}
